module.exports = __webpack_public_path__ + "img/plus_circle_blue.5e717738.svg";